import { useEffect } from 'react';
import './App.css';
import Viewer from './components/Viewer';
import Configurator from './components/Configurator';
import { Toaster } from './components/ui/toaster';
import { ArrowRight } from 'lucide-react';

function App() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="py-4 px-6 border-b border-gray-200/50 bg-white/70 backdrop-blur-md sticky top-0 z-50 animate-slideDown">
        <div className="max-w-[1800px] mx-auto flex items-center justify-between">
          {/* Redsage Logo on left */}
          <div className="flex items-center flex-1">
            <img src="/logo.png" alt="Redsage Logo" className="h-10 w-auto" />
          </div>

          {/* i3DC Logo in center */}
          <div className="flex items-center justify-center flex-1">
            <img src="/i3dc-logo.png" alt="i3DC Logo" className="h-12 w-auto" />
          </div>

          {/* Built in Red Logo on right */}
          <div className="flex items-center justify-end flex-1">
            <img src="/built-in-red-logo.png" alt="Built in Red" className="h-10 w-auto" />
          </div>
        </div>
      </header>

      {/* Main Content - Two Column Layout */}
      <main className="max-w-[1800px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 max-h-[calc(100vh-80px)] gap-0">
          {/* Left Side - 3D Viewer Full Bleed */}
          <div className="flex flex-col items-center justify-center bg-white border-r border-gray-200/50 animate-fadeIn p-6 lg:p-12">
            <div className="w-full max-w-2xl flex flex-col items-center justify-center">

              <div className="text-center space-y-3 mt-0 animate-slideUp">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-gray-50 rounded-full border border-gray-200">
                  <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                  <p className="text-sm font-medium text-gray-700 tracking-wide">
                    360° Interactive View
                  </p>
                </div>
                <p className="text-xs text-gray-500 tracking-wide">
                  Drag to rotate • Scroll to zoom
                </p>
              </div>

              <Viewer />






            </div>
          </div>

          {/* Right Side - Configurator Panel */}
          <div className="flex flex-col bg-white animate-slideInRight h-[calc(100vh-80px)] overflow-hidden">
            <div className="flex-1 overflow-y-auto p-6 lg:p-8">
              <Configurator />
            </div>

         
          </div>
        </div>
           {/* Elegant Footer */}
           <footer className=" fixed bottom-0 left-0 right-0 z-100 bg-white py-3 px-6 lg:px-8 text-center border-t border-gray-200/50 flex-shrink-0">
              <p className="flex text-xs justify-center gap-x-1 text-gray-800 tracking-wide animate-fadeIn">
              <img
                className='w-4 h-4 block my-auto'
                  src='/favicon.ico'
                />
                 Made by
               
                <a
                  className='underline'
                  href='https://redsage.global'
                  target='_blank'>
                  Redsage Global</a>
                <ArrowRight className='h-full my-auto block' size={12} />
              </p>
            </footer>
      </main>

      <Toaster />
    </div>
  );
}

export default App;
